import React, { useState } from "react";
import { Divider, Typography, useMediaQuery } from "@mui/material";

import ExpandInfo from "./ExpandInfo";

const Pas7 = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? "20px" : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -60 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "32.5rem" : "24rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: isMobile ? 10 : 34 }}>
          <div
            variant="contained"
            style={{
              backgroundColor: "#29348f",
              borderRadius: isMobile
                ? "20px 0px 0px 20px"
                : "0px 20px 20px 0px",
              textTransform: "none",
              height: 40,
              width: 80,
              paddingLeft: 16,
              paddingTop: 8,
              marginLeft: isMobile ? "auto" : "",
            }}
          >
            <Typography variant="body1" color="white">
              DEER
            </Typography>
          </div>
          <Typography variant="h6" sx={{ mt: 5 }}>
            Recepția și punerea în funcțiune a instalației de racordare
          </Typography>
          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            La termenul convenit în cadrul contractului de racordare
          </Typography>
          <Typography variant="h6" sx={{ mt: 4 }}>
            Punerea sub tensiune pentru perioada de probe a instalației de
            utilizare
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            În cazul unui loc de consum și producere nou, condiția este ca
            solicitantul să fi depus la operatorul de distribuție cererea de
            punere sub tensiune pentru perioada de probă, însoțită de
            documentația conformă aferentă; În cazul unui spor de putere,
            condiția este ca solicitantul să fi depus la operatorul de
            distribuție dosarul instalației de utilizare conform
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            5 zile lucrătoare de la data punerii în funcțiune a instalației de
            racordare
          </Typography>
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "46rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{ height: "4rem", width: "4px", backgroundColor: "#29348f" }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};
export default Pas7;
